export interface SystemDateTimeFormat {
    date: string;
    time: string;
}

/** Default system date & time formats */
export const DEFAULT_SYSTEM_DATE_TIME_FORMAT_CONFIG: SystemDateTimeFormat = {
    date: 'DD-MM-YYYY',
    time: 'hh:mm:ss a'
};
